import React from 'react';
import { XIcon } from 'lucide-react';
import { PAIN_POINTS } from '../../data/content';
import { Splashes } from '../Splashes';
export function Pain() {
  return <section className="relative w-full overflow-hidden bg-ink px-5 py-12 sm:py-16" data-id="element-160" data-mp="28xpcnwtfih1u">
      <Splashes className="opacity-50" data-id="element-161" data-mp="2dx23esnf889p" />
      <div className="relative mx-auto max-w-4xl text-center" data-id="element-162" data-mp="2hx2go9ysadf6">
        <h2 className="font-display text-3xl leading-tight text-white sm:text-5xl" data-id="element-163" data-mp="2hu7v2f41amk6">
          ¿Cuántas horas más vas a perder armando tus clases?
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-164" data-mp="2rtfijv4hfxl0">
          Amás bailar, pero cada semana terminás buscando música, armando coreografías y pensando
          actividades a último momento.
        </p>
        <p className="mt-4 font-display text-xl text-magenta sm:text-3xl" data-id="element-165" data-mp="35m56i53knckr">
          No es falta de talento. Es falta de un sistema.
        </p>

        <ul className="mx-auto mt-7 grid max-w-4xl gap-2.5 text-left sm:grid-cols-2" data-id="element-166" data-mp="3am9lfqotzz8v">
          {PAIN_POINTS.map(p => <li key={p} className="flex items-start gap-2.5 rounded-xl border border-ink-border bg-ink-card p-3" data-id="element-167" data-mp="20po7z8pgieze">
              <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-red-500" aria-hidden="true" data-id="element-168" data-mp="1wp4a22x277c7" />
              <span className="text-sm leading-snug text-white/80" data-id="element-169" data-mp="1rprdurkasnwy">{p}</span>
            </li>)}
        </ul>

        <p className="mt-7 font-display text-xl text-lime sm:text-3xl" data-id="element-170" data-mp="2kcccmd33s2aj">
          ¿Y si este fuera el último domingo que planificás así?
        </p>
      </div>
    </section>;
}